import { useEffect } from 'react';

import { useAuth } from 'providers/Auth';
import { sendGaView } from 'trackers/ga';

export default function WithTracker({ children, ga }) {
    const {
        liffAuth: { lineId }
    } = useAuth();

    useEffect(() => {
        sendGaView(lineId, ga);
    }, [lineId, ga]);

    return <>{children}</>;
}
